import React from 'react';
import { SearchResult, Conversation } from '../utils/types';

interface SearchResultsProps {
    results: SearchResult[];
    conversations: Conversation[];
    onResultClick: (conversationId: number, messageId: number) => void;
}

const SearchResults: React.FC<SearchResultsProps> = ({
                                                         results,
                                                         conversations,
                                                         onResultClick
                                                     }) => {
    if (results.length === 0) {
        return null;
    }

    return (
        <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-10">
            <div className="p-2">
                {results.map((result, index) => {
                    const conversation = conversations.find(c => c.id === result.conversationId);
                    return (
                        <div
                            key={index}
                            className="p-2 hover:bg-gray-100 rounded cursor-pointer"
                            onClick={() => onResultClick(result.conversationId, result.messageId)}
                        >
                            <div className="text-sm font-medium text-gray-800 truncate">
                                {result.content}
                            </div>
                            <div className="text-xs text-gray-500 mt-1">
                                {conversation?.title || 'Unknown conversation'}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SearchResults;